function ThemeConstants() {
  const UvibesPink = "#DA0B5B";
  const UvibesOrange = "#FE6D00";
  const UvibesYellow = "#FFB001";
  const UvibesGreen = "#78C752";
  const UvibesBlue = "#31BDCA";
  const UvibesRed = "#FF0004";
  const UvibesGray = "#494949";
  const UvibesOrangeGradient = '#F76213'
  const UvibesPinkGradient = '#F62570'
  const backgroundColor = "#FFF4F8";

  return {
    UvibesPink: UvibesPink,
    UvibesOrange: UvibesOrange,
    UvibesYellow: UvibesYellow,
    UvibesGreen: UvibesGreen,
    UvibesBlue: UvibesBlue,
    UvibesRed: UvibesRed,
    UvibesGray: UvibesGray,
    UvibesPinkGradient: UvibesPinkGradient,
    UvibesOrangeGradient: UvibesOrangeGradient,
    backgroundColor: backgroundColor,
  };
}

export default ThemeConstants;
